// Состояние строки «требует действия» словами (0.26.1, ACC-06: решение владельца 01.11.2026).
// Прочтение не значит, что действие выполнено — у строки три состояния:
// - не прочитано — «Требует действия» (и точка непрочитанного, для программ чтения — «Не
//   прочитано:» перед заголовком);
// - прочитано, нужен разбор — «Прочитано, нужен разбор»;
// - разобрано — «Внесено» (ответ внесён), «Закрыто» (отмечено разобранным, проверочный ответ
//   закрыт без изменения пункта), «Вопрос снят» (снят сам: человек ответил, пункт выполнен,
//   отменён, в архиве или человека сняли).
// Ревью 0.26.1 (W4): у снятого вопроса — не «Выполнено». «Выполнено» — слово состояния работы
// в таблице и карточке (ACC-04: одни слова с таблицей), а пункт мог получить новый срок или быть
// отменён. Тон «Вопрос снят» и «Закрыто» — нейтральный, «Внесено» — ok.
// Пометка — словами, не только цветом (README «Табеля»: у пилюли слово обязательно). В карточке
// строка открыта — значит прочитана: до разбора там «Требует действия». Информационные
// уведомления пометки не получают — задачами они не становятся.
import type { Notification } from '@kp/contracts';
import { Badge } from '@kp/ui';

type Resolution = NonNullable<Notification['resolution']>;

export const resolutionTexts = {
  entered: 'Внесено',
  closed: 'Закрыто',
  done: 'Вопрос снят',
} as const satisfies Record<Resolution, string>;

export const ACTION_TEXT = 'Требует действия';
export const OPEN_READ_TEXT = 'Прочитано, нужен разбор';

export interface ActionMarkProps {
  item: Notification;
  /** Карточка открытой строки: до разбора — «Требует действия», без «прочитано». */
  inCard?: boolean;
}

/** Пометка строки «требует действия»; у прочих — ничего. */
export function ActionMark({ item, inCard = false }: ActionMarkProps) {
  if (item.actionRequired !== true) return null;
  if (item.resolution) {
    return (
      <Badge tone={item.resolution === 'entered' ? 'ok' : 'neutral'}>
        {resolutionTexts[item.resolution]}
      </Badge>
    );
  }
  return <Badge tone="warn">{!inCard && item.readAt ? OPEN_READ_TEXT : ACTION_TEXT}</Badge>;
}
